import * as TYPES from './actions/types';

export const initialState = {
  educationArticles: null,
  unreadArticlesCount: 0,
  archivedArticlesCount: 0,
  selectedArticleId: null,
  viewSelectionPreference: { value: 'NewTab' },
};

const educationReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.EDUCATION_ARTICLE_SELECTED:
      newState = { ...state, ...action.state };
      break;
    case TYPES.ARTICLES_LOADED_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.ARTICLES_LOADED_FAILURE:
      newState = { ...state, ...action.state };
      break;
    case TYPES.SINGLE_ARTICLE_LOADED:
      newState = { ...state, ...action.state };
      break;
    case TYPES.UNREAD_COUNT_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.DECREMENT_READ_COUNT: {
      newState = { ...state, unreadArticlesCount: state.unreadArticlesCount - 1 };
      break;
    }
    case TYPES.UNREAD_COUNT_FAILURE:
      newState = { ...state, ...action.state };
      break;
    case TYPES.ARCHIVED_COUNT_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.ARCHIVED_COUNT_FAILURE:
      newState = { ...state, ...action.state };
      break;
    case TYPES.VIEW_PREFERENCE_LOADED_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.VIEW_PREFERENCE_LOADED_FAILED:
      newState = { ...state, ...action.state };
      break;
    case TYPES.VIEW_PREFERENCE_SAVED_SUCCESS: {
      const tempViewSelectionPreference = { ...state.viewSelectionPreference, value: action.value };
      newState = { ...state, viewSelectionPreference: tempViewSelectionPreference };
    }
      break;
    case TYPES.VIEW_PREFERENCE_SAVED_FAILURE:
      newState = { ...state, ...action.state };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default educationReducer;
